import {
  Button,
  ButtonProps,
  ButtonType,
  DropdownItem,
  DropdownItemProps,
  Icon,
  IconProps,
} from 'farmhub-ui-core';
import { Link } from 'react-router-dom';

import { theme } from 'styled';

const Action = ({
  disabled = false,
  children,
  iconProps,
  buttonProps,
  dropdownItemProps,
  onClick,
  renderProp,
  ...props
}: ActionProps): JSX.Element => {
  if (iconProps) {
    return (
      <Icon onClick={onClick} {...iconProps}>
        {children}
      </Icon>
    );
  }
  if (buttonProps) {
    let button = (
      <Button
        disabled={disabled}
        height={theme.button.height.md}
        onClick={onClick}
        {...buttonProps}
      >
        {children}
      </Button>
    );
    if (buttonProps.type === ButtonType.Link) {
      button = (
        <Link to={buttonProps.href || (onClick && onClick())}>{button}</Link>
      );
    }
    return <>{button}</>;
  }
  if (dropdownItemProps) {
    return (
      <DropdownItem onClick={onClick} {...dropdownItemProps} {...props}>
        {children}
      </DropdownItem>
    );
  }
  if (renderProp) {
    return <>{renderProp({ onClick })}</>;
  }

  return <></>;
};

export default Action;

type ClickFunc = (...args: any[]) => any;

export interface ActionProps {
  buttonProps?: Pick<
    ButtonProps,
    Exclude<keyof ButtonProps, 'onClick' | 'children'>
  >;
  iconProps?: Pick<IconProps, Exclude<keyof IconProps, 'onClick'>>;
  dropdownItemProps?: Pick<
    DropdownItemProps,
    Exclude<keyof DropdownItemProps, 'onClick' | 'children'>
  >;
  children?: React.ReactNode;
  disabled?: boolean;
  onClick: ClickFunc;
  renderProp?: ({ onClick }: { onClick: ClickFunc }) => React.ReactNode;
}
